<template>
  <v-form>
    <v-row dense>
      <v-col cols="12" xs="12" md="6">
        <v-text-field name="newDealerNamexx" outlined dense label="Dealer Name" v-model="record.Name"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="6">
        <v-text-field name="newDealerPhonex" outlined dense label="Phone" v-model="record.PhoneNumber"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="6">
        <v-text-field name="newDealerEmailx" outlined dense label="Email" v-model="record.Email"></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn color="accent" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    loader: false,
    date: new Date().toISOString().substr(0, 10)
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    }
  }
};
</script>